module.exports = __webpack_public_path__ + "static/img/Uli-Foguete-Banner.2595e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Uli-Foguete-Banner.png
// module id = 1799
// module chunks = 5